import { Collapse } from '@components/animators/collapse';
import { Card } from '@components/card';
import { FormInstance } from '@components/form/create-form';
import { FormStoreInstance } from '@components/form/create-form-store';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

import { RewardsData } from 'api/jobs/requests';

import { SettingsTitle } from './common';
import { SettingsSwitch } from './common';

import { SettingsLocale } from '../settings';
import { RewardsFormValues } from '../settings';

type RewardsSettingsProps = {
  form: FormInstance<RewardsFormValues>;
  store: FormStoreInstance;
  initialData: RewardsData;
};

export const RewardsSettings = ({ form: Form, store, initialData }: RewardsSettingsProps) => {
  const { t } = useScopedTranslate(SettingsLocale);
  const formValues = store.useFormValues();
  const isRewardsEnabled = formValues.isRewardsEnabled as boolean;
  return (
    <Card variant="transparent" space={6}>
      <Stack space={4}>
        <SettingsTitle title={t('rewards')} description={t('rewardDescription')} />
        <SettingsSwitch<RewardsFormValues>
          label={t('sourcingRewards')}
          enabledText={t('enabled')}
          disabledText={t('disabled')}
          fieldId="isRewardsEnabled"
          isEnabled={isRewardsEnabled}
          form={Form}
          defaultValue={initialData.hasRewards ?? false}
          dataCy="reward-switch"
        />
        <Collapse isCollapsed={!isRewardsEnabled}>
          <Stack space={4}>
            <Stack space={2}>
              <Form.TextField
                id="rewardsTitle"
                dataCy="reward-title"
                defaultValue={initialData.rewardsTitle ?? ''}
                label={t('rewardTitle')}
                validators={isRewardsEnabled ? ['required'] : []}
              />
              <Form.Textarea
                id="rewardsDescription"
                dataCy="reward-description"
                defaultValue={initialData.rewards ?? ''}
                label={t('amountOrReward')}
                validators={isRewardsEnabled ? ['required'] : []}
              />
            </Stack>
          </Stack>
        </Collapse>
      </Stack>
    </Card>
  );
};
